import React, { useState, useEffect, useContext } from "react";
import { Redirect } from "react-router-dom";
import { UserContext } from "../../context/UserContext";
import Header from "../../components/header/Header";

const ExpiredToken = () => {
  const { logoutUser } = useContext(UserContext);
  const [screen, setScreen] = useState(false);
  const [runLogout, setRunLogout] = useState(false);

  useEffect(() => {
    if (!runLogout) {
      logoutUser();
      setRunLogout(true);
    }
  }, [logoutUser, runLogout]);

  useEffect(() => {
    setTimeout(function () {
      setScreen(true);
    }, 2500);
  }, []);

  if (screen) return <Redirect to="/login"></Redirect>;

  return (
    <>
      <Header />
      <div style={{ margin: 90 }}>
        <label className="title">Sua sessão expirou</label>
      </div>
    </>
  );
};

export default ExpiredToken;
